(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    /* Build TOC from H2s in the prose */
    const toc = document.querySelector('[data-mr-toc]');
    const list = document.querySelector('[data-mr-toc-list]');
    const prose = document.querySelector('[data-mr-prose]');
    if (toc && list && prose) {
      const headings = prose.querySelectorAll('h2');
      if (headings.length > 0) {
        headings.forEach((h, i) => {
          if (!h.id) h.id = 'h-' + (i + 1);
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent;
          li.appendChild(a);
          list.appendChild(li);
        });
      } else {
        const body = toc.closest('.mr-post__body');
        if (body) body.classList.add('mr-post__body--no-toc');
        toc.remove();
      }
    }

    /* Copy link button */
    document.querySelectorAll('[data-mr-copy-link]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const url = btn.dataset.url || window.location.href;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(() => {
            btn.classList.add('is-copied');
            setTimeout(() => btn.classList.remove('is-copied'), 1500);
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mr-cart-row]').forEach((row) => {
      const input = row.querySelector('[data-mr-cart-qty-input]');
      row.querySelectorAll('[data-mr-cart-qty]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!input) return;
          const delta = parseInt(btn.dataset.mrCartQty, 10) || 0;
          input.value = String(Math.max(0, (parseInt(input.value, 10) || 0) + delta));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-mr-header]');
    if (!root) return;

    /* ----- Dropdown nav ----- */
    const navItems = root.querySelectorAll('[data-mr-nav-item]');
    let openItem = null;
    const open = (item) => {
      if (openItem && openItem !== item) closeItem(openItem);
      item.classList.add('is-open');
      const trigger = item.querySelector('[data-mr-nav-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      openItem = item;
    };
    const closeItem = (item) => {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-mr-nav-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (openItem === item) openItem = null;
    };
    navItems.forEach((item) => {
      if (!item.classList.contains('mr-nav__item--has-children')) return;
      item.addEventListener('mouseenter', () => open(item));
      item.addEventListener('mouseleave', () => closeItem(item));
      const trigger = item.querySelector('[data-mr-nav-trigger]');
      if (trigger) {
        trigger.addEventListener('focus', () => open(item));
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { closeItem(item); trigger.blur(); }
        });
      }
    });

    /* ----- Mobile menu ----- */
    const mobile = root.querySelector('[data-mr-mobile]');
    const mobileToggle = root.querySelector('[data-mr-mobile-toggle]');
    if (mobile && mobileToggle) {
      mobileToggle.addEventListener('click', () => {
        const open = !mobile.hidden;
        mobile.hidden = open;
        mobileToggle.setAttribute('aria-expanded', String(!open));
      });
    }

    /* ----- Search overlay + predictive search ----- */
    const overlay = root.querySelector('[data-mr-search]');
    const input = root.querySelector('[data-mr-search-input]');
    const results = root.querySelector('[data-mr-search-results]');
    const form = root.querySelector('[data-mr-search-form]');
    const openSearch = () => {
      if (!overlay) return;
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => input && input.focus());
      root.querySelectorAll('[data-mr-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    };
    const closeSearch = () => {
      if (!overlay) return;
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
      root.querySelectorAll('[data-mr-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    };
    root.querySelectorAll('[data-mr-search-toggle]').forEach((btn) => btn.addEventListener('click', openSearch));
    root.querySelectorAll('[data-mr-search-close]').forEach((btn) => btn.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay && !overlay.hidden) closeSearch();
    });

    let abortCtrl = null;
    let debounceId = null;
    const renderHint = (msg) => { if (results) results.innerHTML = '<p class="mr-search__hint">' + msg + '</p>'; };
    const renderEmpty = (term) => { if (results) results.innerHTML = '<p class="mr-search__empty">No results for &quot;' + escapeHtml(term) + '&quot;</p>'; };
    const escapeHtml = (s) => s.replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

    const resolveImage = (p) => {
      if (typeof p.image === 'string' && p.image) return p.image;
      if (p.image && typeof p.image.url === 'string') return p.image.url;
      if (typeof p.featured_image === 'string' && p.featured_image) return p.featured_image;
      if (p.featured_image && typeof p.featured_image.url === 'string') return p.featured_image.url;
      return '';
    };
    const resolvePrice = (p) => {
      const currency = (p.currency)
        || (p.price && p.price.currency_code)
        || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
        || 'USD';
      const fmt = (n) => {
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency', currency,
          }).format(n);
        } catch (e) { return String(n); }
      };
      if (typeof p.price === 'number') return fmt(p.price);
      if (typeof p.price === 'string') {
        const num = parseFloat(p.price);
        if (!isNaN(num) && /^[\d.,\s-]+$/.test(p.price.trim())) return fmt(num);
        return p.price;
      }
      if (p.price && p.price.amount != null) return fmt(parseFloat(p.price.amount));
      return '';
    };
    const fallbackImg = (results && results.dataset.mrFallbackImg) || '';
    const renderResults = (data, term) => {
      if (!results) return;
      const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
      if (products.length === 0) { renderEmpty(term); return; }
      const items = products.map((p) => {
        const img = resolveImage(p) || fallbackImg;
        const price = resolvePrice(p);
        const isFallback = img === fallbackImg && !resolveImage(p);
        return (
          '<li class="mr-search__item">' +
            '<a href="' + p.url + '">' +
              '<span class="mr-search__thumb' + (isFallback ? ' mr-search__thumb--fallback' : '') + '">' +
                (img ? '<img src="' + img + '" alt="" loading="lazy" decoding="async" width="56" height="56">' : '') +
              '</span>' +
              '<span><h4 class="mr-search__title">' + escapeHtml(p.title) + '</h4>' +
              (p.vendor ? '<p class="mr-search__sub">' + escapeHtml(p.vendor) + '</p>' : '') +
              '</span>' +
              '<span class="mr-search__price">' + price + '</span>' +
            '</a>' +
          '</li>'
        );
      }).join('');
      results.innerHTML = '<ul class="mr-search__list">' + items + '</ul>' +
        '<a class="mr-search__see-all" href="/search?q=' + encodeURIComponent(term) + '">See all results →</a>';
    };

    const search = (term) => {
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();
      const url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: abortCtrl.signal, headers: { 'Accept': 'application/json' } })
        .then((r) => r.json())
        .then((d) => renderResults(d, term))
        .catch((err) => { if (err.name !== 'AbortError') renderEmpty(term); });
    };

    if (input) {
      input.addEventListener('input', () => {
        const term = input.value.trim();
        clearTimeout(debounceId);
        if (term.length < 2) { renderHint(input.dataset.hint || 'Start typing to see results'); return; }
        debounceId = setTimeout(() => search(term), 180);
      });
    }
    if (form) {
      form.addEventListener('submit', (e) => {
        if (!input || !input.value.trim()) e.preventDefault();
      });
    }

    /* ----- Cart drawer + AJAX add-to-cart ----- */
    const drawer = document.querySelector('[data-mr-drawer]');
    const drawerItems = drawer && drawer.querySelector('[data-mr-drawer-items]');
    const drawerSubtotal = drawer && drawer.querySelector('[data-mr-drawer-subtotal]');
    const drawerCount = drawer && drawer.querySelector('[data-mr-drawer-count]');
    const cartCountBadges = document.querySelectorAll('[data-mr-cart-count]');

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try { return window.Shopify.formatMoney(cents, window.Shopify.money_format); } catch (e) {}
      }
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency,
        }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    };

    const openDrawer = () => {
      if (!drawer) return;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      document.documentElement.style.overflow = 'hidden';
    };
    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(() => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 260);
    };
    if (drawer) {
      drawer.querySelectorAll('[data-mr-drawer-close], [data-mr-drawer-close-link]').forEach((el) => {
        el.addEventListener('click', (e) => {
          if (el.matches('[data-mr-drawer-close-link]')) return;
          e.preventDefault();
          closeDrawer();
        });
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !drawer.hidden && drawer.classList.contains('is-open')) closeDrawer();
      });
    }

    const sizedImage = (url, w) => {
      if (!url) return '';
      const sep = url.indexOf('?') === -1 ? '?' : '&';
      return url + sep + 'width=' + w;
    };
    const renderDrawerItem = (item, index) => {
      const img = item.image ? '<img src="' + sizedImage(item.image, 240) + '" alt="" loading="lazy" decoding="async">' : '';
      const variant = item.product_has_only_default_variant ? '' :
        '<p class="mr-drawer__variant">' + escapeHtml(item.variant_title || '') + '</p>';
      return (
        '<article class="mr-drawer__row" data-mr-drawer-row data-mr-line="' + (index + 1) + '" data-mr-key="' + escapeHtml(item.key) + '">' +
          '<a href="' + item.url + '" class="mr-drawer__thumb" aria-label="' + escapeHtml(item.product_title) + '">' + img + '</a>' +
          '<div class="mr-drawer__body">' +
            '<h3 class="mr-drawer__product"><a href="' + item.url + '">' + escapeHtml(item.product_title) + '</a></h3>' +
            variant +
            '<div class="mr-drawer__row-foot">' +
              '<div class="mr-stepper" role="group">' +
                '<button type="button" class="mr-stepper__btn" data-mr-drawer-qty="-1" aria-label="Decrease">−</button>' +
                '<span class="mr-stepper__value" data-mr-drawer-qty-value>' + item.quantity + '</span>' +
                '<button type="button" class="mr-stepper__btn" data-mr-drawer-qty="1" aria-label="Increase">+</button>' +
              '</div>' +
              '<span class="mr-drawer__price" data-mr-drawer-price>' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="mr-drawer__remove" data-mr-drawer-remove aria-label="Remove">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M6 18L18 6"/></svg>' +
          '</button>' +
        '</article>'
      );
    };

    const updateCount = (n) => {
      cartCountBadges.forEach((b) => {
        b.textContent = n;
        if (n > 0) b.removeAttribute('hidden');
        else b.setAttribute('hidden', '');
      });
      if (drawerCount) drawerCount.textContent = n;
    };

    const renderDrawer = (cart) => {
      if (!drawer) return;
      drawer.dataset.empty = cart.item_count === 0 ? 'true' : 'false';
      updateCount(cart.item_count);
      if (drawerItems) {
        drawerItems.innerHTML = cart.items.map(renderDrawerItem).join('');
      }
      if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
    };

    const fetchCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

    const addToCart = async (form) => {
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.classList.add('is-loading');
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) {
          const err = await res.json().catch(() => null);
          alert((err && err.description) || 'Could not add to cart.');
          return;
        }
        const cart = await fetchCart();
        renderDrawer(cart);
        openDrawer();
      } catch (e) {
        alert('Network error. Please try again.');
      } finally {
        if (submitBtn) submitBtn.classList.remove('is-loading');
      }
    };

    const updateLine = async (line, quantity) => {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity }),
        });
        if (!res.ok) return;
        const cart = await res.json();
        renderDrawer(cart);
      } catch (e) {}
    };

    /* Hijack any form marked as ATC */
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-mr-atc-form], form[action$="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });

    /* Drawer line item interactions (delegated) */
    if (drawer) {
      drawer.addEventListener('click', (e) => {
        const qtyBtn = e.target.closest('[data-mr-drawer-qty]');
        const removeBtn = e.target.closest('[data-mr-drawer-remove]');
        if (qtyBtn || removeBtn) {
          const row = e.target.closest('[data-mr-drawer-row]');
          if (!row) return;
          const line = parseInt(row.dataset.mrLine, 10);
          if (qtyBtn) {
            const valueEl = row.querySelector('[data-mr-drawer-qty-value]');
            const cur = parseInt(valueEl && valueEl.textContent, 10) || 1;
            const next = Math.max(0, cur + (parseInt(qtyBtn.dataset.mrDrawerQty, 10) || 0));
            updateLine(line, next);
          } else if (removeBtn) {
            updateLine(line, 0);
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const root = document.querySelector('.mr-pdp__top');
    if (!root) return;

    const main = root.querySelector('#mr-pdp-main');
    const thumbs = root.querySelectorAll('[data-mr-thumb]');
    const preloaded = new Set();

    const preload = (btn) => {
      const key = btn.dataset.src;
      if (!key || preloaded.has(key)) return;
      preloaded.add(key);
      const img = new Image();
      if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
      if (main && main.sizes) img.sizes = main.sizes;
      img.src = key;
    };

    thumbs.forEach((btn) => {
      btn.addEventListener('pointerenter', () => preload(btn));
      btn.addEventListener('focus', () => preload(btn));
      btn.addEventListener('click', () => {
        if (!main) return;
        if (btn.dataset.srcset) main.srcset = btn.dataset.srcset;
        main.src = btn.dataset.src || main.src;
        if (btn.dataset.alt != null) main.alt = btn.dataset.alt;
        thumbs.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-current', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-current', 'true');
      });
    });

    const prefetchAll = () => thumbs.forEach(preload);
    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetchAll, { timeout: 2000 });
    } else {
      window.addEventListener('load', prefetchAll);
    }

    const qtyInput = root.querySelector('[data-mr-qty-input]');
    const atc = root.querySelector('[data-mr-atc]');

    root.querySelectorAll('[data-mr-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const delta = parseInt(btn.dataset.mrQty, 10) || 0;
        qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta));
      });
    });

    const variantSelect = root.querySelector('[data-mr-variant-select]');
    const priceEl = root.querySelector('[data-mr-price]');
    const compareEl = root.querySelector('[data-mr-compare]');
    const saveEl = root.querySelector('[data-mr-save]');
    const inputs = root.querySelectorAll('[data-mr-option-input]');

    if (variantSelect && inputs.length) {
      const sync = () => {
        const selected = [];
        root.querySelectorAll('[data-mr-option]').forEach((set) => {
          const checked = set.querySelector('input:checked');
          if (checked) selected.push(checked.value);
        });
        let matched = null;
        for (const opt of variantSelect.options) {
          const opts = (opt.dataset.options || '').split('|||');
          if (opts.length && opts.every((v, i) => v === selected[i])) { matched = opt; break; }
        }
        if (matched) {
          variantSelect.value = matched.value;
          if (priceEl) priceEl.textContent = matched.dataset.price || priceEl.textContent;
          if (compareEl) {
            if (matched.dataset.compare) {
              compareEl.textContent = matched.dataset.compare;
              compareEl.style.display = '';
            } else { compareEl.style.display = 'none'; }
          }
          if (saveEl) {
            if (matched.dataset.save) {
              saveEl.textContent = (saveEl.dataset.label || 'Save') + ' ' + matched.dataset.save;
              saveEl.style.display = '';
            } else { saveEl.style.display = 'none'; }
          }
          if (atc) {
            const available = matched.dataset.available === 'true';
            atc.disabled = !available;
            atc.setAttribute('aria-disabled', String(!available));
          }
        }
      };
      inputs.forEach((i) => i.addEventListener('change', sync));
    }

    /* Tabs */
    const tabRoot = document.querySelector('[data-mr-tabs]');
    if (tabRoot) {
      tabRoot.querySelectorAll('[data-mr-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          const id = tab.dataset.mrTab;
          tabRoot.querySelectorAll('[data-mr-tab]').forEach((t) => {
            t.classList.toggle('is-active', t === tab);
            t.setAttribute('aria-selected', String(t === tab));
          });
          tabRoot.querySelectorAll('[data-mr-panel]').forEach((p) => {
            p.hidden = p.dataset.mrPanel !== id;
          });
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
